/// <reference path="../../include.ts" />

namespace gpx_visualizer_phase2 {

	import View = alm.view.View;

	export class Ground extends View<THREE.LineSegments> {

		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		constructor(center:THREE.Vector2, sizeX:number, sizeZ:number) {
			super();

			this.center = center;
			this.sizeX = sizeX;
			this.sizeZ = sizeZ;

			this.initialize();
		}




		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------

		protected implInitialize():THREE.LineSegments {
			const material:THREE.LineBasicMaterial = new THREE.LineBasicMaterial({
				color: 0xffffff,
				opacity: 0.2,
				transparent: true
			});

			const gridSize:number = 100;

			const boundsTLPixel:THREE.Vector2 = new THREE.Vector2(this.center.x - this.sizeX * 0.5, this.center.y - this.sizeZ * 0.5);
			const boundsBRPixel:THREE.Vector2 = new THREE.Vector2(this.center.x + this.sizeX * 0.5, this.center.y + this.sizeZ * 0.5);

			const segmentCountX:number = Math.round(this.sizeX / gridSize);
			const segmentCountZ:number = Math.round(this.sizeZ / gridSize);

			const stepX:number = this.sizeX / segmentCountX;
			const stepZ:number = this.sizeZ / segmentCountZ;

			const geometry:THREE.Geometry = new THREE.Geometry();

			for (let i:number = 1; i < segmentCountX; ++i) {
				let x:number = boundsTLPixel.x + i * stepX;
				geometry.vertices.push(new THREE.Vector3(x, 0, boundsTLPixel.y));
				geometry.vertices.push(new THREE.Vector3(x, 0, boundsBRPixel.y));
			}

			for (let i:number = 1; i < segmentCountZ; ++i) {
				let z:number = boundsTLPixel.y + i * stepZ;
				geometry.vertices.push(new THREE.Vector3(boundsTLPixel.x, 0, z));
				geometry.vertices.push(new THREE.Vector3(boundsBRPixel.x, 0, z));
			}

			return new THREE.LineSegments(geometry, material);
		}

		protected implReady():void {
		}

		protected implFinalize():void {
		}

		protected implShow(view:THREE.LineSegments, useTransition:boolean):cmd.Command {
			return new cmd.Func(():void => {
				view.visible = true;
			});
		}

		protected implHide(view:THREE.LineSegments, useTransition:boolean):cmd.Command {
			return new cmd.Func(():void => {
				view.visible = false;
			});
		}





		// --------------------------------------------------
		//
		// VARIABLE
		//
		// --------------------------------------------------

		private center:THREE.Vector2;
		private sizeX:number;
		private sizeZ:number;
	}
}
